import React from "react";
import { navigate } from "hookrouter";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import styles from "./Slider.module.css";
import { constants } from "../Dashboard/const";

const Slider = ({ data, dashboard, myStory }) => {
  const sliderRef = React.useRef(null);
  const [hoverItem, setHoverItem] = React.useState(null);
  const [listHover, setListHover] = React.useState(false);
  const [cursor, setCursor] = React.useState(0);
  const [arrows, setArrows] = React.useState([]);
  const [dims, setDims] = React.useState(constants.dims);
  const { width, n_items, margin, totalWidth, heightRatio } = dims;
  const url = myStory ? "mystory" : "story";

  const initWidth = () => {
    const totalW = dashboard
      ? window.innerWidth
      : sliderRef.current.clientWidth;

    const minWidth = totalW < 720 ? 100 : dims.minWidth;

    const n_items = Math.floor((totalW - minWidth) / (minWidth + margin));
    let width = (totalW - n_items * margin) / (n_items + 1);

    setDims({
      ...dims,
      totalWidth: totalW,
      width: width,
      n_items: n_items,
      minWidth: minWidth,
      transitionItems: totalW < 720 ? 1 : 3,
    });
  };

  const handleMove = (direction) => {
    if (direction === 1) {
      // right cursor move
      if (cursor + dims.transitionItems < data.length - n_items) {
        // move 3 if 3 more there
        setCursor(cursor + dims.transitionItems);
        setArrows(["right", "left"]);
      } else {
        // move to last if more to move, to 0 if no more to move
        setCursor(data.length > n_items ? data.length - n_items : 0);
        window.setTimeout(() => setArrows(["left"]), 300);
      }
    } else {
      // left cursor move
      if (cursor - dims.transitionItems > 0) {
        console.log("called");
        setCursor(cursor - dims.transitionItems);
        setArrows(["right", "left"]);
      } else {
        setCursor(0);
        window.setTimeout(() => setArrows(["right"]), 300);
      }
    }
  };

  React.useEffect(() => {
    initWidth();
  }, [sliderRef]);

  React.useEffect(() => {
    if (data.length > n_items) {
      if (cursor === 1) {
        setArrows(["left", "right"]);
      } else {
        setArrows(["right"]);
      }
    } else {
      setArrows([]);
    }
  }, [n_items, data]);

  return (
    <div
      className={styles.container}
      onMouseEnter={() => setListHover(true)}
      onMouseLeave={() => setListHover(false)}
      ref={sliderRef}
      style={{
        width: totalWidth,
        left: 0,
      }}
    >
      {arrows.includes("left") && (listHover || dims.totalWidth < 720) && (
        <div
          className={styles.arrow}
          onClick={() => handleMove(-1)}
          style={{ width: width / 2 - margin, left: 0 }}
        >
          <FaChevronLeft />
        </div>
      )}
      <div
        className={styles.itemsWrapper}
        style={{
          height: width * heightRatio,
          left: width / 2,
          transform: `translateX(${
            cursor * (width + margin) * -1 + (hoverItem ? -40 : 0)
          }px)`,
        }}
      >
        {data.length > 0 &&
          data.map((item, index) => (
            <SliderItem
              data={{
                ...item,
                width: width,
                index: index,
                n_items: n_items,
                cursor: cursor,
              }}
              url={url}
              dims={dims}
              setHoverItem={setHoverItem}
              hoverItem={hoverItem}
              booksLength={data.length}
              key={index}
            />
          ))}
      </div>
      {arrows.includes("right") && (listHover || dims.totalWidth < 720) && (
        <div
          className={styles.arrow + " " + styles.right}
          onClick={() => handleMove(1)}
          style={{
            width: width / 2 - margin,
            left: `calc(100% - ${width * 0.5}px)`,
          }}
        >
          <FaChevronRight />
        </div>
      )}
    </div>
  );
};

const SliderItem = ({ data, setHoverItem, dims, url }) => {
  const visible =
    data.index >= data.cursor && data.index < data.cursor + data.n_items;
  const [hover, setHover] = React.useState(false);
  const backup =
    "https://epic-staging-data.s3.us-east-2.amazonaws.com/upload/cover/5b52bbef53754.gif";
  return (
    <div
      className={`${styles.sliderItemWrapper}`}
      style={{
        padding: hover ? `0 50px 0 40px` : `0 ${dims.margin}px 0 0`,
      }}
    >
      <div
        className={`${styles.item} ${
          !visible ? styles.previewItem : styles.regularItem
        }`}
        style={{
          width: data.width,
          backgroundImage: `url(${data.coverImage}), url(${backup})`,
        }}
        onMouseEnter={
          visible
            ? () => {
                setHoverItem(true);
                setHover(true);
              }
            : () => {
                setHoverItem(false);
                setHover(false);
              }
        }
        onMouseLeave={() => {
          setHoverItem(false);
          setHover(false);
        }}
        onClick={() => navigate(`/${url}/${data._id}`)}
      >
        <div className={styles.info}>
          <div>
            <div className={styles.header}>{data.title}</div>
            {data.postedBy && (
              <div className={styles.author}>
                {data.postedBy.name || "Author"}
              </div>
            )}
          </div>
          <div>
            <div className={styles.tags}>
              {data.tags && data.tags.map((tag, i) => <div key={i}>{tag}</div>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
